import PropTypes from 'prop-types';

function IFGlutenFreeInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M5.35956 12.5915C5.35956 12.5915 5.67618 14.303 8.10643 15.2314C10.5367 16.1599 11.6106 15.0603 11.6106 15.0603C11.2069 13.971 10.4038 13.0761 9.36434 12.5573C7.57588 11.7101 5.35956 12.5915 5.35956 12.5915Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.1908 8.78418C14.1908 8.78418 12.4793 9.10508 11.5508 11.5353C10.6224 13.9656 11.722 15.0395 11.722 15.0395C12.8123 14.6351 13.7074 13.8303 14.225 12.789C15.0721 11.0005 14.1908 8.78418 14.1908 8.78418Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.01985 6.74695C7.01985 6.74695 14.9053 25.5729 16.2574 27.5924C16.5013 27.9475 18.0929 28.5251 17.9688 26.788C17.8961 25.8681 8.74841 5.98535 8.74841 5.98535L7.01985 6.74695Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.3183 15.9375C17.3183 15.9375 15.6068 16.2541 14.6784 18.6844C13.7157 21.1788 14.8495 22.1928 14.8495 22.1928C15.9398 21.7885 16.8349 20.9836 17.3525 19.9423C18.1997 18.1624 17.3183 15.9375 17.3183 15.9375Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.0109 3.6582C11.4974 3.65736 9.04016 4.40192 6.94987 5.79772C4.85957 7.19352 3.23015 9.17787 2.2677 11.4998C1.30524 13.8217 1.05298 16.3769 1.54282 18.8422C2.03266 21.3075 3.24259 23.5721 5.01959 25.3497C6.7966 27.1273 9.06085 28.338 11.526 28.8287C13.9911 29.3194 16.5464 29.068 18.8686 28.1063C21.1908 27.1446 23.1757 25.5159 24.5722 23.426C25.9688 21.3362 26.7141 18.8792 26.7141 16.3657C26.7141 12.9962 25.3759 9.76465 22.9937 7.38165C20.6115 4.99866 17.3804 3.65934 14.0109 3.6582ZM16.531 14.5216C17.9687 13.3621 22.1788 9.32309 22.1788 9.32309C22.4141 9.60976 23.3469 10.8719 23.4282 11.0345C24.3633 12.6819 24.8502 14.5456 24.8402 16.4399C24.8302 18.3341 24.3238 20.1927 23.3713 21.8301C22.4188 23.4675 21.0536 24.8265 19.412 25.7716C17.7703 26.7167 15.9095 27.2148 14.0152 27.2163C10.9175 27.2163 7.84117 25.4021 5.88584 23.3227C5.74037 23.173 9.65958 20.2122 9.65958 20.2122C9.65958 20.2122 14.8025 15.9378 16.531 14.5216ZM4.60226 21.2904C3.78932 20.1908 3.17748 18.0172 3.17748 16.3657C3.17862 13.4932 4.32049 10.7388 6.35204 8.70805C8.38358 6.67731 11.1385 5.53652 14.0109 5.53652C16.4326 5.53652 18.8886 6.79871 20.4759 8.22776L4.60226 21.2904Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.52846 8.27013C3.52846 8.27013 3.84935 9.98158 6.27961 10.91C8.70986 11.8385 9.78379 10.7389 9.78379 10.7389C9.37942 9.64859 8.57458 8.75348 7.53324 8.2359C5.74478 7.38018 3.52846 8.27013 3.52846 8.27013Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.48717 19.7498C8.48717 19.7498 8.80378 21.4612 11.234 22.394C13.6643 23.3267 14.7382 22.2228 14.7382 22.2228C14.3333 21.1318 13.5288 20.2355 12.4877 19.7156C10.7206 18.8727 8.48717 19.7498 8.48717 19.7498Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.3638 4.46191C12.3638 4.46191 10.6523 4.78281 9.71958 7.21306C8.78684 9.64332 9.895 10.7172 9.895 10.7172C10.9853 10.3129 11.8804 9.50804 12.398 8.4667C13.2452 6.67824 12.3638 4.46191 12.3638 4.46191Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.92873 2.78125C5.92873 2.78125 5.05161 4.27877 6.27958 6.57638C7.50754 8.874 9.04784 8.73708 9.04784 8.73708C9.45328 7.64666 9.42881 6.44285 8.97938 5.36981C8.17928 3.56424 5.92873 2.78125 5.92873 2.78125Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.2205 19.7288C21.2205 19.7288 22.6324 18.719 22.4527 16.1219C22.2688 13.4563 20.814 13.0156 20.814 13.0156C19.9973 13.8434 19.5261 14.9509 19.4962 16.1133C19.4877 18.0772 21.2205 19.7288 21.2205 19.7288Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.6748 22.5565C18.6748 22.5565 20.3862 22.7576 22.0078 20.7081C23.6294 18.6587 22.8635 17.3066 22.8635 17.3066C21.7023 17.3735 20.61 17.8798 19.8086 18.7229C18.4822 20.1819 18.6748 22.5565 18.6748 22.5565Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.5242 19.168L20.4503 20.5542"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.3488 17.6874L20.9594 15.4668"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default IFGlutenFreeInactive;

IFGlutenFreeInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFGlutenFreeInactive.defaultProps = {
    className: null,
};
